import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import { buildStrapiUrl, loadAbort } from '@/utils';
import type { StrapiListRequest, StrapiListResponse } from '@/interfaces/strapi';
import type { StrapiResponseModel, TipoEnlacesInteresModel } from '@/interfaces/model';
import { enlacesInteresListMapper } from '@/mappers';

export const getEnlacesInteres = ({
	pagination,
	filter,
	sort,
	populate,
}: StrapiListRequest): UseApiCall<StrapiListResponse<TipoEnlacesInteresModel>> => {
	const controller = loadAbort();

	const url = buildStrapiUrl({
		base: '/tipos-enlaces-de-interes',
		pagination,
		filter: typeof filter === 'object' ? filter : undefined,
		sort,
		populate,
	});

	return {
		call: strapiInstance.get(url, {
			signal: controller.signal,
			transformResponse: [
				(raw: string) => {
					const json = JSON.parse(raw) as StrapiResponseModel<TipoEnlacesInteresModel>;
					return enlacesInteresListMapper(json);
				},
			],
		}),
		controller,
	};
};
